// extracted by mini-css-extract-plugin
export default {"button":"ButtonPlus_button__Gn0lG","icon":"ButtonPlus_icon__5TpfY"};